import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StatusStyle from '../../../../shared/StatusStyle'
import { Tooltip, Popconfirm, message } from "antd"
import TagRequestUpdate from "./TagRequestUpdate"
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router-dom'
import { revertDesignedToPeningForItem } from '../../../../../services/api/3dApi'
import { getLocalData } from '../../../../../services/StorageServices'
import { parseJwt } from '../../../../../helpers/parseToken'

class ItemStatus extends Component {
    state = {
        loadingRevertToPending: false,
    }

    _handleRevertDesignedToPeningForItem = async () => {
        this.setState({ loadingRevertToPending: true })
        const { batchItemId, reloadItems } = this.props || {}
        try {
            const { data: res } = await revertDesignedToPeningForItem(batchItemId)
            const { success, message: mess, error: err } = res || {}
            if (!success) {
                throw new Error(mess || err || 'Unknown error!')
            }
            message.success(`Revert to Pending Sucessed!`)
            reloadItems()
        } catch (error) {
            message.error(error.message)
        } finally {
            this.setState({ loadingRevertToPending: false })
        }
    }

    render() {
        const {
            status,
            is_archive,
            auto_artwork_approve,
            cancelled_reason,
            safezone_warning,
            tags,
            orderId,
            marketplace,
            itemNumber,
            itemsRequest = [],
            lazyload,
            processing_at = '',
            isEmbroidery,
            embroidery_area_info = {},
            productionTags = [],
        } = this.props
        const { loadingRevertToPending } = this.state
        const reason = status === 'cancelled' ? cancelled_reason : ''
        const barcodeNumber = `${marketplace}_${itemNumber}`
        const itemRequest = itemsRequest.filter(item => item.fac_barcode_number === barcodeNumber)
        const isReuseEmbroidery = isEmbroidery && !!embroidery_area_info && embroidery_area_info.hasOwnProperty('reuse_from')
        const { reuse_from = {} } = embroidery_area_info || {}
        const { org_barcode_item = '' } = reuse_from || {}
        const role = parseJwt(getLocalData('accessToken')).roles
        const isAdmin = role.some(item => ['Super Admin', 'fac_admin'].includes(item.name))

        const renderDesignedToPendinConfirm = () => {
            return (
                !!isAdmin && status === 'designed' && isReuseEmbroidery &&
                <Popconfirm
                    title={<div className='DesignedToPendinConfirmText'>
                        <h6 className='mb-0'>Revert to Pending</h6>
                        <span>Bạn có chắc chắn muốn chuyển trạng thái item từ Designed về Pending?</span><br />
                        <span className='text-danger'>Thông tin thêu của item sẽ bị xóa!</span>
                    </div>}
                    okText='Yes'
                    cancelText='No'
                    onConfirm={this._handleRevertDesignedToPeningForItem}
                    overlayClassName='DesignedToPendinConfirm'
                    placement='topRight'
                >
                    <Tooltip title='Revert to Pending'>
                        <a href='' className='mx-2' onClick={(e) => { e.preventDefault() }} disabled={loadingRevertToPending}>
                            <i class="fa fa-undo" style={{ fontSize: 20 }} aria-hidden="true"></i>
                        </a>
                    </Tooltip>
                </Popconfirm>
            )
        }

        const statusContent = (
            <>
                <StatusStyle status={status} note={reason} processing_at={processing_at} />
                {renderDesignedToPendinConfirm()}
                {
                    !!is_archive &&
                    <div>
                        <StatusStyle status="archived" />
                    </div>
                }

                {
                    !!safezone_warning && <div>
                        <Tooltip title={safezone_warning}>
                            <span className="warning">Warning</span>
                        </Tooltip>
                    </div>
                }

                {
                    auto_artwork_approve !== undefined &&
                    <div>
                        <span className="badge autoApprove badge-pill">Auto Approve</span>
                    </div>
                }

                {
                    !!tags && tags.length > 0 &&
                    <div className="TagRequest">
                        {
                            tags.map((tag, index) => {
                                const itemRequestCurrent = itemRequest[index] || {}
                                return <TagRequestUpdate tag={tag} orderId={orderId} key={index} itemRequest={itemRequestCurrent.content || ''} />
                            })
                        }
                    </div>
                }

                {
                    productionTags.includes('Dlican') &&
                    <div className="TagRequest">
                        <div className="badge badge-pill badge-danger">Dlican</div>
                    </div>
                }

                {
                    productionTags.includes('force_cmyk') &&
                    <div className="TagRequest">
                        <div className="badge badge-pill badge-danger">force_cmyk</div>
                    </div>
                }
            </>
        )

        return (
            <td className='ItemStatus'>
                {lazyload ? <LazyLoad>{statusContent}</LazyLoad> : statusContent}

                {!!isEmbroidery && !!marketplace && !!itemNumber &&
                    <div className="linkInfo my-2">
                        <Link className='font-weight-bold' to={`/embroidery?template=${barcodeNumber}`} target='_blank'>Thông tin thêu</Link>
                    </div>
                }
                {isReuseEmbroidery &&
                    <span className="isReuse text-danger font-weight-bold" style={{ whiteSpace: 'nowrap' }}>
                        {`Reuse: ${org_barcode_item}`}
                    </span>
                }
            </td>
        )
    }
}

ItemStatus.propTypes = {
    safezone_warning: PropTypes.string,
    status: PropTypes.string.isRequired,
    is_archive: PropTypes.bool,
}

export default ItemStatus
